import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody44';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy44 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Fundraising support </h2><h4>Portfolio-level Retention Analysis for a technology-focused PE firm</h4>";

  return (
    <>
        <Helmet>
        <title>Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm</title>
        <meta property="og:title" content="Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm" />
        <meta property='og:description' content='Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy41" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy44
